<template>
    <div class="l-ss-c-completions-scrollable">
        <div
            ref="inner"
            class="l-ss-c-completions-inner"
            :class="{
                'l-ss-c-completions-inner-only-offers': !groups.other.length,
                'l-ss-c-completions-inner-has-query': isVisibleShowAllButton
            }"
            @scroll="handleShowBarGradient">
            <div
                class="l-ss-c-completions-inner-left"
                v-if="showEmptySkuOfferTitle || showTaps || groups.other.length">
                <p
                    v-if="showEmptySkuOfferTitle"
                    class="l-ss-c-completions-title">
                    {{ $t('completions.interestTitle') }}
                </p>

                <taps
                    v-if="showTaps"
                    :key="isCompletionsVisible"
                    :query="query"
                    :data="tapsCompletions"
                    is-taps-complitions
                    :count="tapsCount"
                    @handle-tags-click="handleTagsClick"
                    @preview-tab-click="(value) => $emit('preview-tab-click', value)"/>

                <div
                    v-for="(group, groupIndex) in groups.other"
                    :key="groupIndex"
                    class="l-ss-c-completions-group"
                    :class="{ 'l-ss-c-completions-group-with-label': showCompletionsLabel }"
                    @click="handleClick"
                    @contextmenu="handleClick($event, 'contextmenu')">
                    <template v-if="group.label !== 'brands'">
                        <div
                            class="l-ss-c-completions-group-label"
                            v-if="showCompletionsLabel && group.label !== 'suggestions'">
                            {{ $t(`completions.category.${group.label}`) }}
                            <button
                                v-if="group.label === 'history'"
                                @click.stop="handleRemoveAllHistory"
                                class="l-ss-c-completions-group-clear-btn">
                                Очистить
                            </button>
                        </div>

                        <completions-item
                            v-for="(item, itemIndex) in group.items"
                            v-show="isItemVisible(item)"
                            :key="item._id"
                            :data="item"
                            :data-id="item._id"
                            :data-position="itemIndex + 1"
                            :is-active="itemIndex === activeIndex"
                            :is-cart-available="$configuration.features.addToCartButton"
                            :is-cat-prefix-active="$configuration.features.catPrefix"
                            @add-to-cart="offer => $emit('add-to-cart', offer)"
                            @remove-history="hint => $emit('remove-history', hint)"/>
                    </template>

                    <completions-item-brand
                        v-else
                        :brands="group.items"/>
                </div>

                <div
                    v-if="$configuration.skuStrict && completions.length === 0"
                    class="l-ss-c-completions-sku">
                    <p class="l-ss-c-completions-sku-empty-title">{{ $t('completions.emptyResultsBySku') }}</p>
                    <button
                        class="l-ss-c-button l-ss-c-button-large"
                        @click="handleEmptyResetClick">
                        {{ $t('categories.emptyListButtonResetQuery') }}
                    </button>
                </div>
            </div>
            <div
                class="l-ss-c-completions-inner-right">
                <div
                    v-for="(group, groupIndex) in groups.offers"
                    :key="groupIndex"
                    ref="completionsGroup"
                    :class="{
                        'l-ss-c-completions-group-offers': group.label === 'offers',
                        'l-ss-c-completions-group-extra-offers': group.label === 'extraOffers',
                    }"
                    class="l-ss-c-completions-group"
                    @click="handleClick"
                    @contextmenu="handleClick($event, 'contextmenu')"
                    @scroll="handleShowBarGradient">
                    <completions-item-offer-wrapper
                        ref="offersWrapper"
                        :offers="group.items"
                        :offers-label="group.label"
                        :is-catalog-completions="isCatalogCompletions"
                        @add-to-cart-click="handleAddToCartClick"
                        @remove-from-cart-click="$emit('remove-from-cart-click', $event)"/>
                </div>

                <completions-bar
                    v-if="!isCatalogCompletions"
                    ref="completionsBar"
                    :is-visible-show-all-button="isVisibleShowAllButton"
                    @click="handleClickBar"
                    @show-all-click="searchAll"/>

                <!--                <div-->
                <!--                    class="l-ss-c-completions-bar"-->
                <!--                    :class="{ 'l-ss-c-completions-bar-not-empty': isVisibleShowAllButton }"-->
                <!--                    @click="handleClickBar"-->
                <!--                    ref="completionsBar">-->
                <!--                    <template v-if="isVisibleShowAllButton">-->
                <!--                        <button-->
                <!--                            v-if="isVisibleShowAllButton"-->
                <!--                            class="l-ss-c-completions-show-all"-->
                <!--                            @click="searchAll">-->
                <!--                            <span>-->
                <!--                                {{ $t('completions.showAll') }}-->
                <!--                            </span>-->
                <!--                            <i v-html="iconArrowRight"></i>-->
                <!--                        </button>-->
                <!--                    </template>-->
                <!--                </div>-->
            </div>
        </div>
        <completions-bar
            v-if="isCatalogCompletions"
            ref="completionsBar"
            :is-visible-show-all-button="isVisibleShowAllButton"
            @click="handleClickBar"
            @show-all-click="searchAll"/>
    </div>
</template>

<script>
    import CompletionsItem from './completions-item';
    import CompletionsItemBrand from '@/core/components/completions/completions-item-brand.vue';
    import Taps from '@/core/components/taps.vue';
    import CompletionsItemOfferWrapper from '@/core/components/completions/completions-item-offer-wrapper.vue';
    import CompletionsBar from '@/core/components/completions/completions-bar.vue';
    import iconArrowRight from '@/core/assets/images/icons/arrow-top.svg';
    // import LazyLoadOfferImagesMixin from '@/core/mixins/lazyLoadOfferImagesMixin';

    export default {
        components: {
            CompletionsItemOfferWrapper,
            Taps,
            CompletionsItem,
            CompletionsItemBrand,
            CompletionsBar,
        },
        // mixins: [LazyLoadOfferImagesMixin],
        props: {
            completions: {
                type: Array,
                default: () => ([]),
            },
            tapsCompletions: {
                type: Array,
                default: () => ([]),
            },
            isCompletionsVisible: {
                type: Boolean,
                default: false,
            },
            query: {
                type: String,
                default: '',
            },
            isCatalogCompletions: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                activeIndex: null,
                dataSet: {},
                completionTarget: {},
            };
        },
        computed: {
            taps() {
                return {
                    desktop: (this.$configuration.completions?.taps?.desktop) ? this.$configuration.completions?.taps?.desktop : {},
                    mobile: (this.$configuration.completions?.taps?.mobile) ? this.$configuration.completions?.taps?.mobile : {},
                };
            },
            iconArrowRight() {
                return iconArrowRight;
            },
            showTaps() {
                return ((this.$screen.isMobile && this.taps.mobile.active) ||
                    (!this.$screen.isMobile && this.taps.desktop.active)) &&
                    this.tapsCompletions.length;
            },
            tapsCount() {
                return (this.$screen.isMobile) ? this.taps.mobile.count : this.taps.desktop.count;
            },
            groups() {
                let groups = {
                    other: [],
                    offers: [],
                };

                const offerKeys = ['offers', 'extraOffers'];

                const insertCompletion = (completion, completionLabel, groupItem) => {
                    const completionGroup = groupItem.find(group => group.label === completionLabel);
                    if (completionGroup) {
                        completionGroup.items.push(completion);
                    } else {
                        groupItem.push({
                            label: completionLabel,
                            items: [completion],
                        });
                    }
                };

                this.completions.forEach(completion => {
                    const completionLabel = completion.label;

                    if (offerKeys.includes(completionLabel)) {
                        insertCompletion(completion, completionLabel, groups.offers);
                    } else {
                        insertCompletion(completion, completionLabel, groups.other);
                    }
                });

                return groups;
            },
            showCompletionsLabel() {
                return this.$configuration.completions.showCompletionsLabel;
            },
            allCompletionsHidden() {
                return this.completions.some(item => item.visible === true) === false;
            },
            showEmptySkuOfferTitle() {
                return this.skuStrict && this.allCompletionsHidden && this.isSku && this.completions.length > 0;
            },
            skuStrict() {
                return this.$configuration.skuStrict;
            },
            isSku() {
                return Boolean((this.query || '').match(this.$configuration.skuRegExp));
            },
            isVisibleShowAllButton() {
                return this.completions.length > 0 && this.query?.trim();
            },
        },

        watch: {
            completions: {
                handler() {
                    this.$refs.inner.scrollTo(0, 0);
                },
            },
        },
        mounted() {
            this.initShowBarGradientListener();
        },
        methods: {
            isItemVisible(item) {
                return item.visible || this.allCompletionsHidden && this.skuStrict;
            },
            handleEmptyResetClick(event) {
                event.preventDefault();
                event.stopPropagation();
                this.$emit('reset-query');
            },
            handleClickBar(event) {
                const clickPoint = {
                    clientX: event.clientX,
                    clientY: event.clientY,
                };

                const isPointInRect = (point, rect) => {
                    return (
                        point.clientX >= rect.left &&
                        point.clientX <= rect.right &&
                        point.clientY >= rect.top &&
                        point.clientY <= rect.bottom
                    );
                };

                const completionsBar = this.$refs.completionsBar.$el;
                if (completionsBar && isPointInRect(clickPoint, completionsBar.getBoundingClientRect())) {
                    return;
                }

                const completionOffersEl = this.$refs.offersWrapper[0].$refs.completionsOffer;
                const clickedElement = completionOffersEl.find(element =>
                    isPointInRect(clickPoint, element.$el.getBoundingClientRect()),
                );

                if (clickedElement) {
                    const cartButton = clickedElement.$el.querySelector('.l-ss-c-offer-cart-btn');
                    if (cartButton && isPointInRect(clickPoint, cartButton.getBoundingClientRect())) {
                        cartButton.click();
                        return;
                    }
                    clickedElement.$el.click();
                }
            },
            handleClick(event, customEventType = null) {
                event.stopPropagation();
                if (this.completionTarget) {
                    const path = event.path || (event.composedPath && event.composedPath());
                    const completionTarget = path.find(element => element.dataset && element.dataset?.id);
                    if (completionTarget) {
                        const dataSet = completionTarget.dataset;
                        if (completionTarget) {
                            const completion = this.completions.find(item => item._id && item._id === dataSet.id);
                            const groupLabel = this.$t(`completions.category.${completion.label}`);
                            completion.groupLabel = groupLabel;
                            this.$emit('click', {
                                event: event,
                                completion: completion,
                                position: dataSet.position,
                                currentQuery: this.query,
                                customEventType,
                            });
                            this.$emit('params-click', completion);
                        }
                    }
                }
            },
            initShowBarGradientListener() {
                const checkMountNode = () => {
                    const completionsGroup = this.$refs.completionsGroup;

                    if (!completionsGroup || !completionsGroup.length) {
                        setTimeout(checkMountNode);
                        return;
                    }

                    let target = completionsGroup[0];

                    if (this.$screen.isMobile) {
                        target = this.$refs.inner;
                    }

                    this.handleShowBarGradient({ target }, true);
                };

                setTimeout(checkMountNode);
            },
            handleShowBarGradient(event, forceShowGradient = false) {
                const target = event.target;
                const completionsBar = this.$refs.completionsBar.$el;

                if (!completionsBar) {
                    return;
                }

                if ((!target.scrollHeight || Math.round(target.clientHeight + target.scrollTop) >= target.scrollHeight) && !forceShowGradient) {
                    completionsBar.classList.add('l-ss-c-completions-bar-without-gradient');
                } else {
                    completionsBar.classList.remove('l-ss-c-completions-bar-without-gradient');
                }
            },
            handleAddToCartClick(event) {
                event.fromCompletions = true;
                this.$emit('add-to-cart-click', event);
            },
            searchAll(event) {
                this.$emit('search-all');
                this.$emit('preview-show-all-click', { type: 'previewShowAllClick', event });
                this.$emit('show-all-click', {
                    ...event,
                    currentQuery: this.query,
                });
            },
            handleRemoveAllHistory(event) {
                event.shouldRemoveAll = true;
                this.$emit('remove-history', event);
            },
            handleTagsClick(event) {
                this.$emit('tags-click', { tag: event, currentQuery: this.query });
            },
        },
    };
</script>
